import axios from 'axios';

const errors = {
    methodNotExists: ""
}

const methods = {
    get: "get",
    post: "post",
    put: "put",
    delete: "delete",
}

const allowedMethods = ["get", 'post', 'put', 'delete'];

class ServiceCaller {
    token;
    useHeaders = true;

    constructor(address) {
        this.address = address;
        this.methods = methods;
    }

    /** 
     * @param {String} method 
     * @param {String} path 
     * @returns {Promise}  
     */
    call(method, path, request = null) {
        if (!allowedMethods.includes(method)) {
            throw errors.methodNotExists;
        }

        const fullPath = getFullPath(this.address, path);

        return new Promise((res, rej) => {
            if (this.useHeaders) {
                axios.defaults.headers.common['Authorization'] = "bearer " + this.token;
            }

            axios[method](fullPath, request)
                .then(response => {
                    if (this.useHeaders) {
                        delete axios.defaults.headers.common["Authorization"];
                    }
                    res(response.data);
                })
                .catch(error => {
                    if (this.useHeaders) {
                        delete axios.defaults.headers.common["Authorization"];
                    }
                    rej(error)
                })
        })
    }
}

function getFullPath(address, path) {
    return address + path;
}

export default ServiceCaller;